import { render, staticRenderFns } from "./RedemptionOfUrnReturn.vue?vue&type=template&id=ae26da3a&"
import script from "./RedemptionOfUrnReturn.vue?vue&type=script&lang=js&"
export * from "./RedemptionOfUrnReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports